import App from 'app/app.js';
import 'app/service/RouterService.js';

function LtPictureDayFormCtrl(
  $scope,
  $rootScope,
  $routeParams,
  $window,
  $timeout,
  $location,
  $filter,
  RouterService,
  ValidationService,
  MessageStore,
  JobStore,
  LtPictureDayFormCtrlService,
  ContentStore,
  ShoppingCartStore,
  AnalyticsService,
  ErrorLogService,
  SubjectStore,
  GradeService,
  PortraitIdFormatterService,
  JobCleanUpService,
  CommonService,
  DeviceService
) {
  this.portraitId = $scope.portraitId || '';
  this.accessCode = $scope.accessCode || null;
  this.subjectLastName = null;
  this.childGrade = '';
  this.subjectRelationship = null;
  this.relationshipDisclaimer = false;
  this.grades = GradeService.getGrades();
  this.validatingCode = false;
  this.setPortraitId = function () {
    this.portraitId = LtPictureDayFormCtrlService.getJobNumber();
  };
  this.jobLoadFailed = false;

  this.init = function () {
    this.clickSubmitForSmartUrl();
    var self = this;
    this.subjectLastNameInvalid = false;
    this.childGradeInvalid = false;
    this.accessCodeInvalid = false;
    this.portraitIdInvalid = false;
    this.subjectRelationshipInvalid = false;
    this.relationshipDisclaimer = false;
    this.subjectRelationshipDisclaimerSelected = false;

    var unwatchPortraitId = $scope.$watch(
        'portraitId',
        function (portraitId) {
          this.portraitId = portraitId;
        }.bind(this)
      ),
      unwatchAccessCode = $scope.$watch(
        'accessCode',
        function (accessCode) {
          this.accessCode = accessCode;
        }.bind(this)
      ),
      unwatchSubjectLastName = $scope.$watch(
        'subjectLastName',
        function (subjectLastName) {
          this.subjectLastName = subjectLastName;
        }.bind(this)
      ),
      unwatchChildGrade = $scope.$watch(
        'childGrade',
        function (childGrade) {
          this.childGrade = childGrade;
        }.bind(this)
      ),
      unwatchSubjectRelationship = $scope.$watch(
        'subjectRelationship',
        function (subjectRelationship) {
          this.subjectRelationship = subjectRelationship;
        }.bind(this)
      ),
      unwatchJobLoadFailedAction = $rootScope.$on('jobLoadFailed', () => {
        this.jobLoadFailed = true;

        $scope.$broadcast('jobLoadFlagUpdated', true);

        self.validatingCode = false;

        if (!$window.optimizeprepic || this.isPortraitIdEntered()) {
          self.setInvalid();
        }
      });

    $scope.$on('$destroy', function () {
      unwatchPortraitId();
      unwatchAccessCode();
      unwatchSubjectLastName();
      unwatchChildGrade();
      unwatchSubjectRelationship();
      unwatchJobLoadFailedAction();
    });
    if ($scope.pageScope === 'SHOPPING_CART' || $scope.pageScope === 'STUDENT_BANNER') {
      $scope.onInit({ drawer: this });
    }
    this.enableRelationshipDisclaimer = false;
  };

  this.clickSubmitForSmartUrl = function () {
    if (RouterService.smartUrlTriggered) {
      return;
    }

    const redirectedSmartUrlRoute = RouterService.redirectedSmartUrlRoute;

    if (!redirectedSmartUrlRoute) {
      return;
    }

    const { accessCode } = redirectedSmartUrlRoute.routeParams;

    if (accessCode) {
      return;
    }

    RouterService.smartUrlTriggered = true;

    $timeout(() => {
      this.onContinue();
    });
  };

  this.setInvalid = function () {
    this.subjectLastNameInvalid = true;
    this.childGradeInvalid = true;
    this.accessCodeInvalid = true;
    this.portraitIdInvalid = true;
    this.subjectRelationshipInvalid = true;
    this.relationshipDisclaimer = false;
    if (this.isPortraitIdEntered()) {
      this.subjectRelationshipDisclaimerSelected = false;
      this.enableRelationshipDisclaimer = true;
    } else {
      this.subjectRelationshipDisclaimerSelected = false;
      this.enableRelationshipDisclaimer = false;
    }
  };

  this.onCancel = function () {
    if ($scope.pageScope === 'SHOPPING_CART') {
      this.portraitId = null;
      this.accessCode = null;
      this.subjectLastName = null;
      this.childGrade = '';
      this.subjectRelationship = null;
      this.subjectLastNameInvalid = false;
      this.childGradeInvalid = false;
      this.subjectRelationshipDisclaimerSelected = false;
      this.enableRelationshipDisclaimer = false;
      this.accessCodeInvalid = false;
      this.portraitIdInvalid = false;
      try {
        $scope.pictureIdForm.$setPristine();
        $scope.pictureIdForm.$setUntouched();
      } catch (error) {
        ErrorLogService(error);
      }
    }
    if (angular.element('body').hasClass('modal-open')) {
      MessageStore.dismissGrowler();
      angular.element('body').removeClass('modal-open');
    }
    $scope.onCancel();
  };

  this.unCheck = function () {
    this.relationshipDisclaimer = false;
    this.subjectRelationshipDisclaimerSelected = false;
  };

  this.validateData = function () {
    return ValidationService.validate([
      {
        field: $scope.pictureIdForm.accessCode,
        validation: 'required',
        code: 'ACCESS_CODE_REQUIRED'
      },
      {
        field: $scope.pictureIdForm.subjectLastName,
        validation: 'required',
        code: 'CLAIM_CREDENTIALS_REQUIRED_LAST_NAME'
      },
      {
        field: $scope.pictureIdForm.childGrade,
        validation: 'required',
        code: 'CLAIM_CREDENTIALS_REQUIRED_CHILD_GRADE'
      },
      {
        field: $scope.pictureIdForm.subjectRelationship,
        validation: 'required',
        code: 'SUBJECT_RELATIONSHIP_REQUIRED'
      }
    ]);
  };

  this.validateAccountInfo = function () {
    var errors = this.validateData();

    MessageStore.clear();
    if (errors.length > 0) {
      R.forEach(function (error) {
        MessageStore.createSystem(error.code, error.params);
      })(errors);
      $window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    return true;
  };

  this.getPlaceholder = function (key) {
    return $filter('ltTranslateFilter')(key);
  };

  this.getPlaceholderByCountry = function (key) {
    key = ContentStore.appendCountryCode(key);
    return this.getPlaceholder(key);
  };

  this.isValidatingCode = () => Boolean($window.optimizeprepic) && this.validatingCode;

  this.getContinueBtnText = function (key) {
    if (this.isValidatingCode()) {
      return this.getPlaceholder('VALIDATING_YOUR_CODE');
    }
    const btnText = this.getPlaceholderByCountry(key);
    let modifiedText;
    if (btnText) {
      modifiedText = btnText.charAt(0).toUpperCase() + btnText.slice(1).toLowerCase();
    }
    return modifiedText;
  };

  this.onContinue = function () {
    if (this.portraitId?.length === 8) {
      this.portraitId = this.portraitId.replace(/^([a-zA-Z0-9]{4})[- ]?([a-zA-Z0-9]{4}).*/, '$1-$2');
      $scope.$broadcast('updatePortraitId', this.portraitId);
      return;
    }

    if ($scope.pictureIdForm) {
      $scope.pictureIdForm.portraitId.$setDirty();
      $scope.pictureIdForm.portraitId.$setTouched();
      $scope.pictureIdForm.portraitId.$validate();
    }

    if (!JobCleanUpService.cleanUpAndCanAddMoreJobs()) {
      $scope.onCancel();
      return;
    }

    if (!this.isPictureDayFormValid()) {
      return;
    }

    const formData = {};
    if (this.isPortraitIdEntered()) {
      if (this.validateAccountInfo()) {
        formData.portraitId = this.formatInputTextFields(this.portraitId);
        formData.accessCode = this.formatInputTextFields(this.accessCode);
        formData.subjectLastName = this.formatInputTextFields(this.subjectLastName);
        formData.childGrade = this.childGrade;
        formData.subjectRelationship = this.subjectRelationship;
        if (formData.subjectLastName && formData.subjectLastName.length < 2) {
          this.setInvalid();
          return;
        }
        $scope.onContinue({ formData });
      }
    } else {
      if ($window.optimizeprepic) {
        this.validatingCode = true;
      }
      formData.pictureDayId = this.formatInputTextFields(this.portraitId);
      $scope.onContinue({ formData });
    }
  };

  this.formatInputTextFields = function (text) {
    return (text && text.trim().toUpperCase()) || '';
  };

  this.goToGetStarted = function () {
    $scope.isNeedHelpModalShown = true;
    AnalyticsService.recordEvent(AnalyticsService.events.FIND_ID);
  };

  $scope.findMyPictureDay = function ($event) {
    if ($scope.pageScope === 'SHOPPING_CART') {
      $scope.isFindMyPictureDayShown = true;
    } else {
      $event.preventDefault();
      RouterService.findMyPictureDay();
    }
  };

  this.isPortraitIdValid = function () {
    return !!this.portraitId && this.portraitId.length > 0;
  };

  this.toggleDisclaimer = function (self) {
    this.subjectRelationshipDisclaimerSelected =
      self.currentTarget.firstElementChild.id === 'relationshipDisclaimer' &&
      self.currentTarget.firstElementChild.checked === true;
  };

  this.getRelationshipDisclaimer = function () {
    var disclaimer;
    if (this.subjectRelationship === 'ParentGuardian') {
      disclaimer = this.getPlaceholderByCountry('PICTURE_DAY_PARENT_GUARDIAN_DISCLAIMER');
    } else {
      disclaimer = this.getPlaceholderByCountry('PICTURE_DAY_GRANDPARENT_OTHER_DISCLAIMER');
    }
    return disclaimer;
  };

  this.setRelationshipDisclaimer = function () {
    this.enableRelationshipDisclaimer = this.subjectRelationship && this.isPortraitIdEntered();
  };

  //this function is to add a hyphen to portrait id when there is no hyphen or having space is given portrait id
  this.portraitIdHyphenCheck = function () {
    this.portraitId = PortraitIdFormatterService.format(this.portraitId);
  };

  this.isAccessCodeValid = function () {
    return !!this.accessCode && this.accessCode.trim().length > 0;
  };

  this.isPortraitIdEntered = function () {
    const isPortraitIdEntered = PortraitIdFormatterService.isFormattedPortraitId(this.portraitId);
    $rootScope.$broadcast('portraitIdEntered', isPortraitIdEntered);
    return isPortraitIdEntered;
  };

  this.isSubjectLastNameValid = function () {
    return !!this.subjectLastName && this.subjectLastName.length > 0;
  };

  this.isChildGradeValid = function () {
    return !!this.childGrade && this.childGrade.length > 0;
  };

  this.isSubjectRelationshipValid = function () {
    return !!this.subjectRelationship && this.subjectRelationship.length > 0;
  };

  this.checkAccessCode = function () {
    this.accessCode = PortraitIdFormatterService.checkAccessCode(this.accessCode);
  };

  this.validateInput = function (formControl) {
    if (formControl.$name === 'ID') {
      this.portraitIdInvalid = !this.isPortraitIdValid();
    }

    if (formControl.$name === 'accessCode') {
      this.accessCodeInvalid = !this.isAccessCodeValid();
    }

    if (formControl.$name === 'subjectLastName') {
      this.subjectLastNameInvalid = !this.isSubjectLastNameValid();
    }

    if (formControl.$name === 'childGrade') {
      this.childGradeInvalid = !this.isChildGradeValid();
    }

    if (formControl.$name === 'subjectRelationship') {
      this.subjectRelationshipInvalid = !this.isSubjectRelationshipValid();
    }
  };

  this.disableShopNowButton = function () {
    if (this.isPortraitIdEntered()) {
      return !(
        this.isAccessCodeValid() &&
        this.isSubjectLastNameValid() &&
        this.isChildGradeValid() &&
        this.isSubjectRelationshipValid() &&
        this.subjectRelationshipDisclaimerSelected
      );
    }
    return this.isValidatingCode();
  };

  this.isCodeInputDisabled = () => this.isValidatingCode();

  this.isPictureDayFormValid = function () {
    return (
      this.isPortraitIdValid() &&
      (!this.isPortraitIdEntered() ||
        (this.isAccessCodeValid() &&
          this.isSubjectLastNameValid() &&
          this.isChildGradeValid() &&
          this.isSubjectRelationshipValid()))
    );
  };

  this.resetFormValues = function () {
    this.portraitId = null;
    this.accessCode = '';
    this.subjectLastName = null;
    this.childGrade = '';
    this.subjectRelationship = null;
    MessageStore.clear();
  };

  this.getPopover = function () {
    var pictureDayText = ContentStore.getContent(
      'MOBILE_TRANS_HOME',
      ContentStore.appendCountryCode('POPOVER_PICTURE_DAY_ID_TEXT')
    );
    var pictureDayImage = ContentStore.getContentImageUrl(
      'MOBILE_TRANS_HOME',
      ContentStore.appendCountryCode('POPOVER_PICTURE_DAY_ID_IMAGE')
    );
    var pictureDayAlt = ContentStore.getContent('MOBILE_TRANS_HOME', 'POPOVER_PICTURE_DAY_ID_IMAGE_ALT');

    var portraitIdText = ContentStore.getContent(
      'MOBILE_TRANS_HOME',
      ContentStore.appendCountryCode('POPOVER_PORTRAIT_ID_TEXT')
    );
    var portraitIdImage = ContentStore.getContentImageUrl(
      'MOBILE_TRANS_HOME',
      ContentStore.appendCountryCode('POPOVER_PORTRAIT_ID_IMAGE')
    );
    var portraitIdAlt = ContentStore.getContent('MOBILE_TRANS_HOME', 'POPOVER_PORTRAIT_ID_IMAGE_ALT');

    return (
      '' +
      '<div class="digital-info-popover">' +
      '<p class="mara-dark-grey f5 text-center">' +
      pictureDayText +
      '</p>' +
      '   <div><img src="' +
      pictureDayImage +
      '" alt="' +
      pictureDayAlt +
      '"/></div>' +
      '   <p class="f5 mara-dark-grey text-center top-24">' +
      portraitIdText +
      '</p>' +
      '   <div><img src="' +
      portraitIdImage +
      '" alt="' +
      portraitIdAlt +
      '"/></div>' +
      '</div>'
    );
  };

  this.getPopoverForRelationShip = function () {
    var toolTipText = ContentStore.getContent(
      'MOBILE_TRANS_HOME',
      ContentStore.appendCountryCode('POPOVER_RELATIONSHIP')
    );
    return '<div class="digital-info-popover"><p class="f5 text-center">' + toolTipText + '</p> </div>';
  };

  this.getVerifiedStudents = function () {
    SubjectStore.sortVerifiedSubject();
    return SubjectStore.getVerifiedSubjects();
  };

  this.addNewStudent = function () {
    $scope.onNavigateToNextPage({ flow: 'ADD_NEW_STUDENT' });
  };

  this.verifiedStudentSelected = function (masterSubject) {
    SubjectStore.loadMasterSubjectEvents(masterSubject).then(function () {
      SubjectStore.setSelectedSubject(masterSubject);
      $scope.onNavigateToNextPage({ flow: 'EVENT_LIST' });
    });
    this.close();
  };

  this.goToIDontHaveCode = function () {
    $scope.onCancel();
    RouterService.goToIDontHaveCode();
  };

  this.open = function () {
    this.visible = true;
  };

  this.close = function () {
    this.visible = false;
  };

  this.onChangeAction = function () {
    this.jobLoadFailed = false;
    this.setRelationshipDisclaimer();
    this.unCheck();
  };

  this.getContinueBtnSize = () => (DeviceService.isMobile() ? 'medium' : 'large');
}

App.controller('LtPictureDayFormCtrl', [
  '$scope',
  '$rootScope',
  '$routeParams',
  '$window',
  '$timeout',
  '$location',
  '$filter',
  'RouterService',
  'ValidationService',
  'MessageStore',
  'JobStore',
  'LtPictureDayFormCtrlService',
  'ContentStore',
  'ShoppingCartStore',
  'AnalyticsService',
  'ErrorLogService',
  'SubjectStore',
  'GradeService',
  'PortraitIdFormatterService',
  'JobCleanUpService',
  'CommonService',
  'DeviceService',
  LtPictureDayFormCtrl
]);
